import { EMPTY_STRING } from '@src/core/config';
import { arcToFixed } from '@src/core/extensions';

/**
 * Mission Delivery Alt = Mission Destination Alt - (Settings Takeoff Alt - Settings Delivery Alt)
 */
export const calculateMissionDeliveryAltitude = (
  destinationAltitude: string | number,
  settingsTakeoffAlt: string | number,
  settingsDeliveryAlt: string | number,
): string => {
  const destination = Number(destinationAltitude);
  const settingsTakeoff = Number(settingsTakeoffAlt);
  const settingsDelivery = Number(settingsDeliveryAlt);

  if (
    !Number.isFinite(destination)
    || !Number.isFinite(settingsTakeoff)
    || !Number.isFinite(settingsDelivery)
  ) {
    return destinationAltitude != null && destinationAltitude !== ''
      ? String(destinationAltitude)
      : EMPTY_STRING;
  }

  const offset = settingsTakeoff - settingsDelivery;
  return arcToFixed(destination - offset, 1);
};
